import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';

import {NavigationKey} from '../config/navigation.config';
import {AdminDoctorsScreen} from '../../screens';

import {NavigationTitle} from '../config/navigationTitle';

const {Navigator, Screen} = createStackNavigator();

const AdminDoctorsStackNavigator = () => {
  return (
    <Navigator initialRouteName={NavigationKey.ADMIN_DOCTORS_LIST}>
      <Screen
        name={NavigationKey.ADMIN_DOCTORS_LIST}
        component={AdminDoctorsScreen}
        options={{
          headerShown: false,
          title: NavigationTitle.ADMIN_DOCTORS_LIST,
        }}
      />
    </Navigator>
  );
};

export default AdminDoctorsStackNavigator;
